/* =============================================================================
   JEFFERY OWEN'S × STYLECRAFT — Theme JavaScript
   Handles: scroll reveal, sticky nav, mobile menu, video play, cart
   ============================================================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ── STICKY HEADER ──────────────────────────────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── MOBILE MENU ────────────────────────────────────────────────────────────
  const menuBtn  = document.querySelector('.header-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  const closeBtn  = document.querySelector('.mobile-nav-close');

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (closeBtn && mobileNav) {
    closeBtn.addEventListener('click', () => {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }
  // Close on link click
  document.querySelectorAll('.mobile-nav-links a').forEach(link => {
    link.addEventListener('click', () => {
      mobileNav && mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  });

  // ── SCROLL REVEAL ──────────────────────────────────────────────────────────
  const revealEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
  if (revealEls.length) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          // Stagger siblings within the same parent
          const siblings = Array.from(entry.target.parentElement.querySelectorAll('.reveal, .reveal-left, .reveal-right'));
          const idx = siblings.indexOf(entry.target);
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, idx * 80);
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => revealObserver.observe(el));
  }

  // ── VIDEO SECTION ─────────────────────────────────────────────────────────
  // Video playback (autoplay, mute toggle, loop, end-screen) is handled
  // by the inline <script> inside each video-section.liquid instance.
  // The .vs-player pattern replaces the old .video-wrapper pattern.
  //
  // Legacy .video-wrapper support (image-text section video embeds):
  document.querySelectorAll('.video-embed-wrap .play-btn-overlay').forEach(btn => {
    const wrap   = btn.closest('.video-embed-wrap');
    const poster = wrap && wrap.querySelector('.video-poster-img');
    const iframe = wrap && wrap.querySelector('.video-iframe');
    const video  = wrap && wrap.querySelector('.video-mp4');
    if (!btn) return;
    btn.addEventListener('click', () => {
      if (poster) poster.style.display = 'none';
      btn.style.display = 'none';
      if (iframe) {
        iframe.src = iframe.dataset.src;
        iframe.style.display = 'block';
      } else if (video) {
        video.style.display = 'block';
        video.play();
      }
    });
  });

  // ── HERO WORD REVEAL ───────────────────────────────────────────────────────
  const heroContent = document.querySelector('.hero-content');
  if (heroContent) {
    const heroEls = heroContent.querySelectorAll('[data-hero-reveal]');
    heroEls.forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(32px)';
      el.style.transition = `opacity 600ms cubic-bezier(0.23,1,0.32,1) ${200 + i * 90}ms, transform 600ms cubic-bezier(0.23,1,0.32,1) ${200 + i * 90}ms`;
      setTimeout(() => {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }, 100);
    });
  }

  // ── NEWSLETTER FORM ────────────────────────────────────────────────────────
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = form.querySelector('.newsletter-input');
      const btn   = form.querySelector('.newsletter-submit');
      if (input && input.value) {
        btn.textContent = 'SUBSCRIBED ✓';
        btn.style.background = '#4CAF50';
        input.value = '';
        setTimeout(() => {
          btn.textContent = 'SUBSCRIBE →';
          btn.style.background = '';
        }, 3000);
      }
    });
  });

  // ── CART COUNT (Shopify Ajax) ───────────────────────────────────────────────
  const updateCartCount = () => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  };
  updateCartCount();

  // ── ADD TO CART ────────────────────────────────────────────────────────────
  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'ADDED ✓';
        updateCartCount();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(() => {
        btn.textContent = 'TRY AGAIN';
        btn.disabled = false;
      });
    });
  });

});
